import { render, staticRenderFns } from "./faultForm.vue?vue&type=template&id=0712884e&scoped=true"
import script from "./faultForm.vue?vue&type=script&lang=js"
export * from "./faultForm.vue?vue&type=script&lang=js"
import style0 from "./faultForm.vue?vue&type=style&index=0&id=0712884e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0712884e",
  null
  
)

export default component.exports